import { ChangeDetectionStrategy, Component, input, Input, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { AbstractFormElement } from '../abstract-form-element';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollIntoViewDirective } from '../scroll-into-view.directive';
import { SelectModule } from 'primeng/select';
import { FormElementComponent } from '../form-element/form-element.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-form-dropdown',
  templateUrl: './form-dropdown.component.html',
  styleUrls: ['./form-dropdown.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormElementComponent,
    SelectModule,
    ScrollIntoViewDirective,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
  ],
})
export class FormDropdownComponent extends AbstractFormElement<SelectItem[]> implements OnInit {
  @Input()
  options: SelectItem[] = [];

  @Input()
  filter = false;

  @Input()
  placeholder?: string;

  virtualScroll = input(false);

  ngOnInit(): void {
    super.ngOnInit();
    if (!this.formControl.value && this.options.length > 0 && !this.placeholder) {
      this.formControl.setValue(this.options[0].value);
    }
  }
}
